import { DestroyRef, Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '@environment';
import { AuthenticationService } from '@auth';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigService } from '@core';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {
  constructor(
    private router: Router,
    private destroyRef: DestroyRef,
    private readonly authService: AuthenticationService,
    private readonly configService: ConfigService
  ) {}

  public initPostHog() {
    if (!this.configService.config.posthogKey || this.configService.config.posthogKey === '') {
      return;
    }

    posthog.init(this.configService.config.posthogKey, {
      api_host: 'https://eu.i.posthog.com',
      debug: false,
      cross_subdomain_cookie: true,
      capture_pageview: false,
      capture_pageleave: false,
      capture_exceptions: false,
      autocapture: false,
      loaded: posthogInstance => {
        this.router.events
          .pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe((event: NavigationEnd) => {
            posthogInstance.capture('$pageview');
          });
      },
      before_send: event => {
        // Disable sending exceptions to PostHog from Angular as we want these to be handled by Sentry
        if (event.event == '$exception') {
          return null;
        }
      }
    });
  }

  public capture(event: string) {
    posthog.capture(event, {
      distinctId: this.authService.user.id.toString()
    });
  }
}
